<ng-container *ngIf="!!content">
  <ng-template [ngTemplateOutlet]="content">
  </ng-template>
</ng-container>